// extracted by mini-css-extract-plugin
export default {"table":"Table_table__YUzYe","symbol":"Table_symbol__wQrxs","name":"Table_name__oOAQn"};